import { FavoriteBorder, Reply } from "@mui/icons-material";
import { Icon } from "@mui/material";
import AdvertisementCard from "components/cards/AdvertisementCard";
import Classifieds from "components/classifieds/classifieds";
import { get, index } from "services/post/ClassifiedService";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import Comments from "components/comments/comments";
import Slider from "react-slick";
import styled from "@emotion/styled";
import { parseISO } from "date-fns";
import Contact from "components/contact/contact";
import Advertising from "components/ad/Advertising";
import placeholder from "images/placeholder-small.png";
import placeholderAvatar from "data/avatars/avatar.jpg";

const ClassifiedDetail: React.FC = () => {
  const [data, setData]: any = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSimilares, setLoadingSimilares] = useState(true);
  const [dataSimilares, setDataSimilares] = useState([]);
  const { id } = useParams();

  const urlBase = process.env.REACT_APP_BACKEND_API_URL;

  const [dataBanner, setDataBanner] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [id]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const response = await get(id);
      setData(response.data);
      setDataBanner(response.data.attachments);

      fetchSimilares(response.data);

      setLoading(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  const fetchSimilares = async (data: any) => {
    setLoadingSimilares(true);
    try {
      const response = await index({ category_id: data.category_id, page_size: 4 });

      let dataTmp = response.data.filter((item: any) => item.id != id);
      dataTmp = dataTmp.slice(0, 4);

      setDataSimilares(dataTmp);

      setLoadingSimilares(false);
    } catch (error) {
      toast.error("Erro ao carregar os dados");
    }
  };

  // : any = [
  //   {
  //     src: "https://casacor.abril.com.br/wp-content/uploads/sites/7/2022/01/Casa-Liu-Raiz-Arquitetura-Foto-Leonardo-Giantomasi-2.jpg?quality=90&strip=info&w=1024&crop=1",
  //   },
  //   {
  //     src: "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  //   },
  //   {
  //     src: "https://hips.hearstapps.com/hmg-prod/images/kips-bay-dallas-2021-kitchen-studio6f-1632327008.jpg?crop=1.00xw:0.702xh;0,0.155xh",
  //   },
  //   {
  //     src: "https://www.bhg.com/thmb/P9Rim_gdPPufBkeK9OLO2jFzogY=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/7003788_DeMattia_0110-1_preview-ff1207461932428fb33bcbf9d682cb9d.jpg",
  //   },
  //   {
  //     src: "https://st.hzcdn.com/simgs/pictures/porches/hammock-lake-residence-orlando-comas-landscape-architect-img~60e18686094d41f8_14-1105-1-4da17af.jpg",
  //   },
  // ];

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = windowWidth < 768;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
  };

  return (
    <div className="flex flex-1 justify-center items-center">
      <div className="flex flex-col px-4 sm:px-0 w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] overflow-hidden">
        <Slider {...settings}>
          {dataBanner.map((item: any, index: any) => (
            <img
              alt="Foto"
              className="rounded-3xl w-1/2 lg:w-1/3 h-40 sm:h-64 lg:h-96 object-cover p-1 zoom-on-hover height-max"
              src={
                urlBase +
                "/storage/images/posts/classifieds/attachments/" +
                item.path
              }
              onError={(e) => (e.currentTarget.src = placeholder)}
            ></img>
          ))}
        </Slider>

        {/* <div className="flex justify-between cursor-grab overflow-x-scroll scroll-smooth">
          <img
            alt="Foto"
            className="rounded-3xl w-1/2 lg:w-1/3 h-40 sm:h-64 lg:h-96 object-cover"
            src="https://casacor.abril.com.br/wp-content/uploads/sites/7/2022/01/Casa-Liu-Raiz-Arquitetura-Foto-Leonardo-Giantomasi-2.jpg?quality=90&strip=info&w=1024&crop=1"
          ></img>
          <img
            alt="Foto"
            className="rounded-3xl w-1/2 lg:w-1/3 h-40 sm:h-64 lg:h-96 object-cover"
            src="https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
          ></img>
          <img
            alt="Foto"
            className="rounded-3xl w-1/2 lg:w-1/3 h-40 sm:h-64 lg:h-96 object-cover"
            src="https://hips.hearstapps.com/hmg-prod/images/kips-bay-dallas-2021-kitchen-studio6f-1632327008.jpg?crop=1.00xw:0.702xh;0,0.155xh"
          ></img>
          <img
            alt="Foto"
            className="rounded-3xl w-1/2 lg:w-1/3 h-40 sm:h-64 lg:h-96 object-cover"
            src="https://www.bhg.com/thmb/P9Rim_gdPPufBkeK9OLO2jFzogY=/750x0/filters:no_upscale():max_bytes(150000):strip_icc():format(webp)/7003788_DeMattia_0110-1_preview-ff1207461932428fb33bcbf9d682cb9d.jpg"
          ></img>
          <img
            alt="Foto"
            className="rounded-3xl w-1/2 lg:w-1/3 h-40 sm:h-64 lg:h-96 object-cover"
            src="https://st.hzcdn.com/simgs/pictures/porches/hammock-lake-residence-orlando-comas-landscape-architect-img~60e18686094d41f8_14-1105-1-4da17af.jpg"
          ></img>
        </div> */}

        <div className="my-10">
          <div className="flex-row mb-10">
            <span className="w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem]">
              <Link to={"/"}>Home</Link> &gt;{" "}
              <Link to={"/classificados"}>Classificados</Link>&gt;{" "}
              <Link to={""}> {data.name}</Link>
            </span>
          </div>
          <span className="bg-primary-600 text-white text-xs font-medium me-2 px-2.5 py-0.5 rounded-full">
            {data.category?.name ?? ""}
          </span>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "end",
              width: "86%",
            }}
            className="m-2"
          ></div>

          <div className="flex flex-col lg:flex-row gap-x-8 px-8 sm:px-0 overflow-hidden w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[79rem] justify-between">
            <div className="w-full pt-10">
              <div className="mb-10">
                <h1 className="text-3xl font-semibold">{data.name ?? ""}</h1>

                <div className="mt-5">
                  <span className="text-primary-600 text-sm ">
                    Localização:{" "}
                  </span>
                  <p className="text-md">
                    {(data.address?.address ?? "") +
                      " - " +
                      (data.address?.district ?? "") +
                      ", " +
                      (data.address?.city ?? ", ") +
                      " - " +
                      (data.address?.state ?? "")}
                  </p>
                </div>

                {data.value && (
                  <h1 className="text-3xl font-semibold mt-5">
                    {(data.currency?.sigle ?? "") + " " + (data.value ?? "")}
                  </h1>
                )}

                <div className="mt-10">
                  <span className="mt-10 text-primary-600">Descrição:</span>
                  <div
                    className="space-y-2 text-justify"
                    dangerouslySetInnerHTML={{ __html: data.description ?? "" }}
                  ></div>
                </div>
              </div>
            </div>

            <div className="flex flex-1 flex-col h-fit items-center lg:items-end pt-5 gap-y-10">
              {data.length != 0 ? (
                <div className="flex rounded-full w-full h-full">
                  <div className="rounded-full h-full w-12 object-cover">
                    <img
                      alt=""
                      className="rounded-full w-[2.5rem] h-[2.5rem] object-cover"
                      src={
                        process.env.REACT_APP_BACKEND_API_URL +
                        "/storage/users/" +
                        data.post.user.avatar_path
                      }
                      onError={(e) => (e.currentTarget.src = placeholderAvatar)}
                    ></img>
                  </div>
                  <div className="mx-2 items-center">
                    <div className="flex justify-between items-center">
                      <div className="flex-col justify-between items-center">
                        <div className="">
                          <div>
                            <span className="text-gray-600 font-medium mb-[-18px]">
                              {data.post.user.display_name}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : null}

              {data?.video_url && (
                <div className="w-full h-[12rem] sm:w-full sm:h-[20rem] md:w-[40rem] md:h-[23rem] lg:w-full lg:h-[16rem] border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl overflow-hidden">
                  <iframe
                    className="border-[#F8F8F8] dark:border-[#1D2432] rounded-3xl border-8"
                    width="450"
                    height="260"
                    src={data.video_url}
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  ></iframe>
                </div>
              )}

              <Contact post_type_id={4} post_id={data.post_id} classe={'relative flex flex-col group rounded-2xl overflow-hidden bg-primary-50 dark:bg-gray-600 w-96 h-96 align-center p-2'} />
            </div>
          </div>

          <div className="my-20">
            <hr className="opacity-75 dark:opacity-20" />
          </div>

          <div
            className="
                        flex flex-col lg:flex-row mb-20 justify-center gap-x-16 gap-y-20
                        w-full sm:w-[37rem] md:w-[45rem] lg:w-[62rem] xl:w-[80rem] px-2
                    "
          >
            <Comments
              dados={data}
              tela="classifieds"
              url="/posts/classifieds/comment"
              urlAnswer="/posts/classifieds/answer"
              get={fetchData}
              classe="flex flex-col w-full"
            />

            {/* <div className="flex justify-center items-center w-full lg:w-[400px] h-[16rem] lg:h-auto rounded-xl bg-gray-300">
              <span className="text-2xl font-semibold">ADS</span>
            </div> */}
            <div className="w-full md:w-[300px] lg:w-[400px] mt-5 md:mt-0 pb-10">
              <Advertising type="vertical" subCategoryId={data?.subcategory?.id} />
            </div>

          </div>
          {/* Anúncios */}
          {
            dataSimilares.length != 0 ? (
              <div className="mt-20">
                <h1 className="text-4xl font-bold text-primary-600 [font-family:'Poppins-ExtraBold',Helvetica]">
                  Anúncios Similares
                </h1>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 place-items-center py-8 gap-8 justify-evenly">
    
                  {
                    dataSimilares.map((item: any) => (
                      <AdvertisementCard
                        adImg={
                          urlBase +
                          "/storage/images/posts/classifieds/attachments/" +
                          item.attachments[0]?.path ?? ""
                        }
                        adTitle={item.name ?? ""}
                        adDescription={item.description ?? ""}
                        adPrice={
                          (item.currency?.sigle ?? "") + " " + (item.value ?? "")
                        }
                        authorImg={
                          urlBase +
                          "/storage/users/" +
                          item.post?.user?.avatar_path ?? ""
                        }
                        authorName={item.post?.user?.name ?? ""}
                        adDate={item.created_at ?? ""}
                        id={item.id ?? ""}
                      />
                    )) 
                  } 
                </div>
              </div>
            ) : null
          }
          {/*<Classifieds />*/}
        </div>
      </div>
    </div>
  );
};

export default ClassifiedDetail;
